import * as React from "react";
import Svg, { SvgProps, Mask, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={29} height={28} fill="none" {...props}>
    <Mask id="a" fill="#fff">
      <Path
        fillRule="evenodd"
        d="M12 2c0 6.627-5.373 12-12 12 6.627 0 12 5.373 12 12 0-6.627 5.373-12 12-12-6.627 0-12-5.373-12-12Z"
        clipRule="evenodd"
      />
    </Mask>
    <Path
      fill="#000"
      d="M0 15c7.18 0 13-5.82 13-13h-2c0 6.075-4.925 11-11 11v2Zm13 11c0-7.18-5.82-13-13-13v2c6.075 0 11 4.925 11 11h2Zm11-13c-7.18 0-13 5.82-13 13h2c0-6.075 4.925-11 11-11v-2ZM11 2c0 7.18 5.82 13 13 13v-2c-6.075 0-11-4.925-11-11h-2Z"
      mask="url(#a)"
    />
    <Path fill="#FFFFFF" d="M12 0h15v28H12z" />
    <Path stroke="#000" d="M4.5 14h24" />
  </Svg>
);
export default SvgComponent;
